import { SANITARY_FEATURES_IN_DISPLAY_ORDER } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import type { StepProps } from './types';
import { FormCheckboxGroup } from '../FormControls';
import { ParkingSpacesField } from '../ListFields';

export const SanitaryParkingStep: React.FC<StepProps> = ({ disabled, realEstateIndex }) => {
    const { t } = useTranslation();
    const prefix = `immobilien.${realEstateIndex}.baubeschreibung.sanitaerGaragen` as const;
    return (
        <div className="space-y-3">
            <FormCheckboxGroup
                name={`${prefix}.sanitaereEinrichtung`}
                label={t('REAL_ESTATE.BUILDING_DESCRIPTION.GROUPS.SANITARY')}
                options={SANITARY_FEATURES_IN_DISPLAY_ORDER.map((value) => ({
                    label: t(`REAL_ESTATE.BUILDING_DESCRIPTION.OPTIONS.SANITARY.${value}`),
                    value,
                }))}
                disabled={disabled}
            />
            <ParkingSpacesField realEstateIndex={realEstateIndex} disabled={disabled} />
        </div>
    );
};
